import { useEffect } from "react"
import { router } from "@inertiajs/react"

const POLLING_STATUSES = ["generating_script", "rendering", "uploading"]
const POLL_INTERVAL_MS = 15_000

export function usePodcastPolling(podcastStatus) {
  useEffect(() => {
    if (!POLLING_STATUSES.includes(podcastStatus)) return

    let timeoutId
    let cancelled = false

    const poll = () => {
      if (cancelled) return

      // Pause polling when tab is not visible
      if (document.visibilityState === "hidden") {
        timeoutId = setTimeout(poll, POLL_INTERVAL_MS)
        return
      }

      router.reload({
        only: ["article"],
        preserveState: true,
        preserveScroll: true,
        onFinish: () => {
          if (!cancelled) {
            timeoutId = setTimeout(poll, POLL_INTERVAL_MS)
          }
        },
      })
    }

    timeoutId = setTimeout(poll, POLL_INTERVAL_MS)

    return () => {
      cancelled = true
      clearTimeout(timeoutId)
    }
  }, [podcastStatus])
}
